export const RightsConstants = Object.freeze({
  INSUFFICIENT_RIGHTS_TOAST: 'insufficient_rights_toast',
});
